export default "__VITE_ASSET__KO$d4BEE__"